(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tasjesfan-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tf-product__gallery').forEach((gallery) => {
  const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-index]'));
  const activeImage = gallery.querySelector('.tf-product__active-image');
  const lightbox = gallery.querySelector('.tf-product__lightbox');
  const lightboxImage = lightbox?.querySelector('img');
  const counter = lightbox?.querySelector('.tf-product__lightbox-counter');
  let activeIndex = 0;

  const showImage = (index) => {
    if (!thumbnails.length || !activeImage) return;
    activeIndex = (index + thumbnails.length) % thumbnails.length;
    const source = thumbnails[activeIndex].dataset.imageSrc;
    activeImage.src = source;
    activeImage.removeAttribute('srcset');
    thumbnails.forEach((thumbnail, thumbnailIndex) => {
      if (thumbnailIndex === activeIndex) thumbnail.setAttribute('aria-current', 'true');
      else thumbnail.removeAttribute('aria-current');
    });
    if (lightboxImage) {
      lightboxImage.removeAttribute('srcset');
      lightboxImage.removeAttribute('sizes');
      lightboxImage.src = source;
    }
    if (counter) counter.textContent = `${activeIndex + 1} / ${thumbnails.length}`;
  };

  const previous = () => showImage(activeIndex - 1);
  const next = () => showImage(activeIndex + 1);

  thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => showImage(index)));
  gallery.querySelector('.tf-product__gallery-arrow--previous')?.addEventListener('click', previous);
  gallery.querySelector('.tf-product__gallery-arrow--next')?.addEventListener('click', next);
  gallery.querySelector('.tf-product__zoom-trigger')?.addEventListener('click', () => {
    showImage(activeIndex);
    lightbox?.showModal();
  });
  lightbox?.querySelector('.tf-product__lightbox-arrow--previous')?.addEventListener('click', previous);
  lightbox?.querySelector('.tf-product__lightbox-arrow--next')?.addEventListener('click', next);
  lightbox?.querySelector('.tf-product__lightbox-close')?.addEventListener('click', () => lightbox.close());
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });
  lightbox?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') previous();
    if (event.key === 'ArrowRight') next();
  });
  showImage(0);
});

document.querySelectorAll('.tf-product').forEach((productSection) => {
  const favoriteContainer = productSection.querySelector('.tf-product__favorite-app');
  const toast = productSection.querySelector('.tf-product__favorite-toast');
  const toastMessage = toast?.querySelector('.tf-product__favorite-toast-message');
  let toastTimer;

  const showFavoriteMessage = (message) => {
    if (!toast || !toastMessage) return;
    clearTimeout(toastTimer);
    toastMessage.textContent = message;
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    toastTimer = setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => { toast.hidden = true; }, 220);
    }, 3200);
  };

  const syncFavoriteButton = () => {
    const button = favoriteContainer?.querySelector('button.wk-button');
    if (!button) return;
    const label = button.getAttribute('aria-label') || '';
    const saved = /verwijder|remove/i.test(label) || button.getAttribute('aria-pressed') === 'true';
    button.classList.toggle('is-favorite', saved);
  };

  syncFavoriteButton();
  if (favoriteContainer) {
    favoriteContainer.addEventListener('click', (event) => {
      const button = event.target.closest('button.wk-button');
      if (!button) return;
      const removing = button.classList.contains('is-favorite') || button.getAttribute('aria-pressed') === 'true';
      button.classList.toggle('is-favorite', !removing);
      button.setAttribute('aria-pressed', removing ? 'false' : 'true');
      showFavoriteMessage(removing ? 'Verwijderd uit favorieten' : 'Toegevoegd aan favorieten');
      setTimeout(syncFavoriteButton, 1200);
    }, true);
    new MutationObserver(syncFavoriteButton).observe(favoriteContainer, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'aria-pressed'] });
  }
});

  } catch(e) { console.error(e); }
})();
})();
